export default "__VITE_ASSET__BJ2ghYGc__"